import Vue from "vue";
import Vuex from "vuex";
import clienteNamespace from "./modules/cliente"
import usuarioNamespace from "./modules/usuario"
import ventasNamespace from "./modules/ventas"
import deudasNamespace from "./modules/deudas"
import articulosNamespace from "./modules/articulos"

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    clienteNamespace,
    usuarioNamespace,
    ventasNamespace,
    deudasNamespace,
    articulosNamespace
  }
});
